<template>
   <!-- page-wrapper Start-->
    <div class="page-wrapper">
        <div class="container-fluid">
            <!-- sign up page start-->
            <div class="authentication-main">
                <div class="row">
                    <div class="col-sm-12 p-0">
                        <div class="auth-innerright">
                            <div class="authentication-box">
                                <div class="gradient-gy card p-1">
                                    <div class=" d-flex flex-row justify-content-between ">
                                        <div v-if="showForecast">
                                            <feather @click="arrowBTN_Lucking" class="text-white mt-4" type="arrow-left-circle"  size="30"></feather>                                            
                                        </div>
                                        <div v-else>
                                            <a href="javascript:void(0)" v-on:click="toggle_fullscreen()">
                                                <feather class="text-white mt-4 ml-2"  type="maximize" size="25"></feather>
                                            </a>                                            
                                        </div>
                                        <h4 v-show="showForecast" class="text-center text-white mt-1">{{ $t('lucking.title') }}</h4>
                                        <!-- <div v-show="!showForecast" class="text-center"><img src="../../assets/images/lifeG.png" style="width: 85%; height: 90%;" alt=""></div> -->
                                        <div v-show="!showForecast" class="text-center"><img src="../../assets/images/hor-th_100.png" alt=""></div>                                        
                                        <div class="mt-4"  style="text-align: end"><LocaleSwitcher/></div>                                     
                                    </div>
                                    <label v-show="!showForecast" class="text-center text-white" style="font-size: 16px;">{{ $t('lucking.title') }}</label>
                                    <h6 v-show="!showForecast" class="text-center text-dark ">{{ $t('lucking.ref') }}</h6>

                                    <form class="theme-form">
                                        <div class="form-row">
                                            <div v-show="!showForecast" class="col-sm-12">
                                                <div class= "row mx-2">
                                                    <h5 class="text-dark f-w-800">{{ $t('lucking.name') }}</h5>
                                                    <span class="ml-2 text-dark f-w-800" style="font-size: 16px">{{ name }}</span>                                                        
                                                </div>
                                                <div class= "row mx-1">
                                                    <b-alert v-model="showAlertAddCC" variant="success" dismissible class="m-2">
                                                        <span class="alert-heading text-warning" style="font-size: 16px;">{{ $t('refill.alertHeaderAddCC') }}</span>
                                                        {{ $t('refill.alertAddCC') }}
                                                    </b-alert>                                                              
                                                    <b-alert v-model="showAlertAddOL" variant="info" dismissible class="m-5">
                                                        <h5 class="alert-heading">{{ $t('refill.alertHeaderAddOL') }}</h5>
                                                        {{ $t('refill.alertAddOL') }}
                                                    </b-alert>  
                                                    <div class=" mx-auto gradient-yg rounded-pill d-flex flex-wrap justify-content-center"> 
                                                        <div class="d-flex justify-content-center"> 
                                                            <feather type="shopping-bag" stroke-width="3" size="20" class="mt-3 ml-1 text-primary"></feather> 
                                                            <h6 class="text-dark ml-1 mt-3 f-w-800">{{ $t('refill.wallet')}}</h6>
                                                            <h6 class="text-primary f-w-900 mx-2 mt-3">{{ balanced }}</h6>                                                            
                                                        </div>

                                                        <!-- <h6 class="text-dark ml-2 mt-3 mr-1">{{ $t('refill.mUnit') }}</h6>                                                         -->
                                                        <!-- <feather type="plus-circle" stroke-width="3" size="22" class="mt-2 mx-2"></feather> -->
                                                        <div class="d-flex justify-content-center"> 
                                                            <b-button-group>
                                                                <b-button size="sm" pill  @click="showAlertAddCC = true" variant="success" class="gradient-gw ">
                                                                    <feather type="plus-circle" stroke-width="3" size="18" class="text-warning  mt-2 mr-1"></feather>
                                                                    <span class="f-w-600 text-dark mb-2" style="font-size: 14px;">{{ $t('refill.addCC') }} </span>
                                                                </b-button>
                                                                <b-button size="sm" pill @click="goRefillOL" variant="info" class="ml-1 gradient-wg ">
                                                                    <feather type="plus-circle" stroke-width="3" size="18" class="text-primary  mt-2 mr-1"></feather>
                                                                    <span class="f-w-600 text-dark mb-2" style="font-size: 14px;">{{ $t('refill.addOL') }} </span>
                                                                </b-button>
                                                            </b-button-group>   
                                                        </div>                                              
                                                    </div>
                                                </div>
                                                <div class="ml-2 mt-3 d-flex justify-content-between">
                                                    <div class="d-flex justify-content-start">
                                                        <label for="ftName" class="text-dark ml-1 f-w-600" style="font-size: 16px;" >{{ $t('lucking.ftName') }}</label> 
                                                    </div>
                                                    <div class="d-flex justify-content-end" v-b-popover.hover.left="$t('lucking.lrsInfo') " >
                                                        <h6 class=" gradient-gr rounded p-1 text-white f-w-800 mr-1">{{ $t('lucking.lrs') }}</h6>
                                                        <h6 v-show="lrs !== '' " class="text-dark p-1  f-w-800 " style="font-size: 16px;" >{{ lrs.split('/')[0] }}</h6>     
                                                    </div>                                                         
                                                </div>
                                                <div class="mx-2">
                                                    <input class="form-control" id="ftName" v-model="ftName" type="text" :placeholder="$t('lucking.ftNamePh')">
                                                </div>
                                                <div class="row ml-1 mt-3" v-b-popover.hover.top="$t('lucking.lrsFor')">
                                                    <h6 class="text-dark f-w-600 ml-1" style="font-size: 16px">{{ $t('lucking.inputDateTimePlace') }}</h6>                                                            
                                                </div>  
                                                <div class="d-flex flex-wrap justify-content-start">
                                                    <div class="mx-1">
                                                        <label for="dayBD" class="text-danger f-w-600" style="font-size: 14px">{{ $t("lucking.day") }}</label>
                                                        <b-form-select class="border-info" label="selectedDayBD" v-model="selectedDayBD" :options="dayList" > </b-form-select>
                                                    </div>
                                                    <div class="mx-1">
                                                        <label for="monthBD" class="text-danger f-w-600" style="font-size: 14px">{{ $t('lucking.month') }}</label>
                                                        <b-form-select class="border-info" label="selectedMonthBD" v-model="selectedMonthBD" :options="monthList" > </b-form-select>
                                                    </div>
                                                    <div class="mx-1">
                                                        <label for="yearBD" class="text-danger f-w-600" style="font-size: 14px" >{{ $t('lucking.year') }}</label>
                                                        <b-form-select class="border-info" label="selectedYearBD" v-model="selectedYearBD" :options="yearBDList" > </b-form-select>
                                                    </div>
                                                </div>   
                                                <div class="d-flex flex-wrap justify-content-between mt-2">
                                                    <div v-show="statusTimeBD != 'accepted'" @click="resetEstTime()" class="mx-1">
                                                        <label for="timeBD" class="text-danger f-w-600" style="font-size: 14px">{{ $t('lucking.clock') }}</label>
                                                        <b-form-timepicker 
                                                            v-model="selectedTimeBD" 
                                                            @input="resetBothLrs"
                                                            reset-button
                                                            :label-reset-button="$t('lucking.reset')"
                                                            :label-close-button="$t('lucking.close')"
                                                            :label-no-time-selected="$t('lucking.noTimeSelected')"
                                                            :placeholder= "$t('lucking.timePh')" 
                                                            locale="th"
                                                        >
                                                        </b-form-timepicker>
                                                        <b-button 
                                                            pill 
                                                            v-show="showNoTimeBD_BTN || selectedTimeBD != '' " 
                                                            size="sm" @click="noTimeBD_BTN" 
                                                            variant="outline-secondary" 
                                                            class=" gradient-yg col-sm-12 mt-2" 
                                                            v-b-popover.hover.bottom="$t('lucking.noTimeBD_BTNMsg')"
                                                        >
                                                            <span class="f-w-600 text-danger mb-2" style="font-size: 18px;">{{ $t('lucking.noTimeBD_BTN') }} </span>
                                                        </b-button>
                                                    </div>
                                                    <div class="mx-1">
                                                        <label for="placeBD" class="text-danger f-w-600" style="font-size: 14px" >{{ $t('lucking.place') }}</label>
                                                        <b-form-select class="border-info" label="selectedPlaceBD" v-model="selectedPlaceBD" :options="placeList" > </b-form-select>
                                                    </div>
                                                </div> 
                                                <div>
                                                    <div v-show="selectedTimeBD === '' " class="row ml-2 mt-2" v-b-hover="handleHover"  style=" cursor: pointer" >
                                                        <b-form-checkbox
                                                            class="text-danger f-w-600"
                                                            style="font-size: 16px; font-weight: bold" 
                                                            id="checkbox-1"
                                                            v-model="statusTimeBD"
                                                            name="checkbox-1"
                                                            value="accepted"
                                                            unchecked-value="not_accepted"
                                                            plain
                                                        >
                                                            {{ $t('lucking.noTimeBD') }}
                                                        </b-form-checkbox>                                                       
                                                        <span v-show="isHovered" class="text-danger mx-2">{{ $t('lucking.estTime')  }} </span>
                                                    </div>
                                                    <div v-show="statusTimeBD == 'accepted'" class="row col-sm-12">
                                                        <div class="col-sm-5">
                                                            <label for="selectedLrs" class="text-primary f-w-600" style="font-size: 14px" >{{ $t('lucking.lrs') }}</label>
                                                            <b-form-select class="border-info" label="selectedLrs" v-model="selectedLrs" :options="rsList" @input="resetLrs" @change="resetSelectedEstTime"> </b-form-select>
                                                        </div>
                                                        <div class="col-sm-7"> 
                                                            <b-form-group  v-slot="{ ariaDescribedby }">
                                                                <b-form-radio-group
                                                                    class="text-info " 
                                                                    id="radio-group-2"
                                                                    v-model="selectedEstTime"
                                                                    @input="resetBothLrs"
                                                                    :aria-describedby="ariaDescribedby"
                                                                    name="estTime"
                                                                     plain
                                                                    stacked
                                                                >
                                                                    <b-form-radio value="t-00-06">{{ $t('lucking.t-00-06') }}</b-form-radio>
                                                                    <b-form-radio value="t-06-12">{{ $t('lucking.t-06-12') }}</b-form-radio>
                                                                    <b-form-radio value="t-12-18">{{ $t('lucking.t-12-18') }}</b-form-radio>
                                                                    <b-form-radio value="t-18-00">{{ $t('lucking.t-18-00') }}</b-form-radio>
                                                                    <b-form-radio value="t-xx-xx">{{ $t('lucking.t-xx-xx') }}</b-form-radio>
                                                                </b-form-radio-group>
                                                            </b-form-group>                                                             
                                                        </div>
                                                    </div>
                                                </div>        
                                                <div class="ml-2 mt-3">
                                                    <h6 class="text-dark f-w-800" style="font-size: 17px">{{ $t('lucking.forecastDateTime') }}</h6>                                                            
                                                </div>                                                     
                                                <div class="row ml-2">
                                                    <div class="mx-1">
                                                        <label class="text-danger f-w-600" style="font-size: 14px">{{ $t("lucking.halfMthly") }}</label>
                                                        <b-form-select v-model="selectedHalf">
                                                            <b-form-select-option :value="''" disabled>{{ $t('lucking.plsSelectHalfType') }}</b-form-select-option>
                                                            <b-form-select-option value="F">{{ $t('lucking.firstHalf') }}</b-form-select-option>
                                                            <b-form-select-option value="L" >{{ $t('lucking.lateHalf') }}</b-form-select-option>
                                                        </b-form-select>
                                                    </div>
                                                </div>
                                                <div class="row col-sm-12 my-2">  
                                                    <div class=" col-sm-6">
                                                        <label for="month" class="text-danger f-w-600" style="font-size: 14px">{{ $t('lucking.month') }}</label>
                                                        <b-form-select class="text-dark f-w-400" label="selectedMonth" v-model="selectedMonth" :options="monthList" > </b-form-select>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <label for="year" class="text-danger f-w-600" style="font-size: 14px" >{{ $t('lucking.year') }}</label>
                                                        <b-form-select class="text-dark f-w-400" label="selectedYear" v-model="selectedYear" :options="yearList" > </b-form-select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>                                        
                                    <div class="form-row d-flex flex-row justify-content-between ml-3">
                                        <div v-if="!showForecast" >
                                            <button rounded @click="handleLuck" class=" gradient-rbl text-white" style="font-size: 16px" size="md">{{ $t('lucking.doLuck') }}</button>
                                        </div>
                                        <div v-else >
                                            <button  @click="reLuck" class="btn-primary gradient-rbl " size="md">{{ $t('lucking.reLuck') }}</button>
                                        </div>
                                        <div v-if="!showForecast" >
                                            <button  @click="doCancel" class=" text-primary gradient-rw " size="sm">{{ $t('lucking.cancel') }}</button>
                                        </div>
                                        <!-- <div v-else>
                                            <b-button pill @click="generateReport" class="text-primary gradient-rw " size="md">{{ $t('lucking.genPdf') }}</b-button>
                                        </div> -->
                                        <div >
                                            <button pill @click="$bvModal.show('bv-modal-exit')" class="btn-danger mr-3" size="sm">{{ $t('lucking.exit') }}</button>
                                        </div>
                                    </div>
                                    <b-modal
                                        v-model="showModalEstTime"
                                        :title="this.$t('lucking.selectChrTitle')"
                                        header-bg-variant="info"
                                        header-text-variant="light"
                                        body-bg-variant="light"
                                        body-text-variant="dark"
                                        footer-bg-variant="warning"
                                        footer-text-variant="dark"
                                        >
                                        <b-container fluid>
                                            <b-row class="mb-1 text-start">
                                            <b-col>{{ this.$t('lucking.selectChrInfo') }}</b-col>
                                            </b-row>
                                            <b-row class="mb-1">
                                            <b-col>
                                                <b-form-select
                                                    v-model="selectedChrLrs"
                                                    :options="chrList"
                                                    class="mb-3"
                                                    value-field="rsTH"
                                                    text-field="character"
                                                    disabled-field="notEnabled"
                                                ></b-form-select>
                                            </b-col>
                                            </b-row>
                                        </b-container>
                                        <template #modal-footer>
                                            <div class="w-100">
                                                <b-button
                                                    variant="warning"
                                                    size="sm"
                                                    class="float-right"
                                                    @click="showModalEstTime = false"
                                                >
                                                    {{$t('refillOL.no') }}
                                                </b-button>
                                                <b-button
                                                    variant="primary"
                                                    size="sm"
                                                    class="float-right"
                                                    @click="modalEstTime_OK"
                                                >
                                                    {{$t('refillOL.ok') }}
                                                </b-button>
                                            </div>
                                        </template>
                                    </b-modal>                                    
                                    <b-modal id="bv-modal-exit" hide-footer>
                                        <template #modal-title>
                                        {{ $t('lucking.exitTitle') }}
                                        </template>
                                        <div class="d-block text-center">
                                        <h3>{{$t('lucking.confirm2Exit') }}</h3>
                                        </div>
                                        <b-button class="mt-3 btn-danger" block @click="doExit">{{$t('lucking.exit') }}</b-button>
                                    </b-modal>
                                    <div class="text-center mt-2"><img
                                        class="frameB"
                                        src="../../assets/images/horaWings320.png" 
                                        alt="A responsive image, Hora">
                                    </div>     
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { signOut} from "firebase/auth";
import { authUser, offsetMinLoc, getCalendarWithDate ,getPlaceList, verifyExstFC , getBalance, getDocById, getDataWithDocId, saveWithId, uaTxWallet } from "../../firebase"
import  { day, month, year , up, wkwk }  from "../../constants/hor-th"
import { getRsCharacter, getLrsFromSr, getSunRiseTime, getRandomInt} from "../../utilities/util"
import Rasee from '../../data/rasee.json'
import LocaleSwitcher from "../../components/localSwitcher.vue"

export default {
    components: { LocaleSwitcher },
    name: 'lucking',
    data() {
        return{
            userId : '',
            name: '',
            statusTimeBD : "no Time BD",
            showNoTimeBD_BTN : true,
            showAlertAddCC: false,
            showAlertAddOL: false,
            isHovered: false,
            minList : [],
            hourList : [], 
            dayList : day,               
            monthList : [],     
            yearList : [],
            yearBDList : [],
            ftName : '',                        
            selectedDayBD : '',
            selectedMonthBD : '',
            selectedYearBD : '',
            selectedTimeBD : '',
            selectedPlaceBD: '',
            selectedEstTime: '',
            prevFtName: '',
            prevDayBD : '',
            prevMonthBD : '',
            prevYearBD : '',
            prevTimeBD : '',
            prevPlaceBD: '',
            prevEstTime: '',      
            lrs: '', // TH Name/nn
            selectedHalf : '',
            selectedMonth : '',
            selectedYear : '',
            placeList : [],
            balanced: 0,
            // fileUrl: '',
            showForecast : false,
            selectedLrs : '',
            rsList : [],
            showModalEstTime : false,
            chrList : [],
            selectedChrLrs : '',  // rsTH or TH Name/nn
            textToExport: 'This is the text I want to export.',
            imageSrc: 'path/to/your/image.jpg', // Or a data URL
            htmlContent: '<p style="color: blue;">This is <strong>HTML</strong> content.</p>'
        }
    },
    mounted(){
        this.userId = localStorage.getItem("userId")        
        this.rsList = this.getRsList()
        this.monthList = month
        this.yearList = this.getYearFtList()
        this.yearBDList = this.getYearBDList()        
        getPlaceList((res)=>{
            this.placeList = res 
        })
        getBalance(this.userId , (res)=>{
            this.balanced = res
        })        
        getDocById("Users", "userId", this.userId, (res)=>{
            this.name = res[0].name
            this.ftName = res[0].ftName
            this.selectedDayBD =  res[0].dayBD
            this.selectedMonthBD = res[0].monthBD
            this.selectedYearBD =  res[0].yearBD
            this.selectedTimeBD = res[0].timeBD            
            this.selectedPlaceBD = res[0].placeBD    
            // this.selectedEstTime = res[0].estTime            
            this.lrs = res[0].lrs
            this.prevLrs = res[0].lrs
            this.prevFtName = res[0].ftName
            this.prevDayBD = res[0].dayBD
            this.prevMonthBD = res[0].monthBD
            this.prevYearBD = res[0].yearBD
            this.prevTimeBD = res[0].timeBD            
            this.prevPlaceBD = res[0].placeBD    
            // this.prevEstTime = res.estTime    
        })    
        this.selectedYear = `${new Date().getFullYear() + 543 } /${new Date().getFullYear()}`
        this.selectedMonth = `${month[new Date().getMonth()]}`
    },
    methods: {
        resetBothLrs(){
            this.selectedLrs = ''
            this.lrs = ''
        },
        resetSelectedEstTime(){
            this.selectedEstTime = ''
        },        
        resetLrs(){
            this.lrs = ''
        },
        getRsList(){
            let rsThList = Rasee.data.map((doc)=>{
                return doc.rsTH
            })
            return rsThList
        }, 
        getStartDate(wk){
            let w = [] 
            wkwk.filter(i=> {
                if (i.ww == wk) {
                    w.push(i.startDate)
                }                
            })
           return w[0]
        },
        updateBalance(userId){
            getBalance(userId, (res)=>{
                this.balanced = res
            })
        },   
        getYearBDList(){
            let yearNow = `${new Date().getFullYear() + 543 } /${new Date().getFullYear()}`
            let yearNowArrNum = year.indexOf(yearNow)
            return year.slice(0,yearNowArrNum)
        },
        getYearFtList(){
            let yearNow = `${new Date().getFullYear() + 543 } /${new Date().getFullYear()}`
            let yearNowArrNum = year.indexOf(yearNow)
            return year.slice(yearNowArrNum , year.length)
        },

        resetEstTime(){
            this.selectedEstTime = ''
        },

        handleHover(hovered) {
            this.isHovered = hovered
        },
        doCancel(){
            this.ftName = '',                                    
            this.selectedDayBD = '',
            this.selectedMonthBD = '',
            this.selectedYearBD = '',
            this.selectedHalf = '',
            this.selectedMonth = '',
            this.selectedYear = '',
            this.selectedTimeBD= '',
            this.selectedPlaceBD = '',
            this.selectedEstTime = '',
            this.lrs = ''
            this.selectedLrs = ''
            this.showForecast = false
            this.displayForecastTime =''
            this.$toasted.show(this.$t('lucking.cancelMsg'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 5000});  
        },
        arrowBTN_Lucking(){
            if (this.showForecast) {
                this.reLuck()
            } else {
                this.$bvModal.show('bv-modal-exit')
            }            
        },
        doExit(){
            localStorage.clear('user')
            localStorage.clear('userId')
            localStorage.clear('userCat')
            localStorage.clear('phone')
            localStorage.clear('name')     
            this.$bvModal.hide('bv-modal-exit')                   
            signOut(authUser);
            this.$router.push('/auth/login')
        },
        goRefillOL(){
            this.$router.push('/process/refillOL')
        },
        reLuck(){                                 
            this.selectedHalf = ''
            this.showForecast = false
            this.displayForecastTime = ''
        },
        handleLuck(){
            let fcTS =  Date.parse(`${this.selectedYear.split('/')[1]}/${(this.selectedMonth.split('/')[1])}/1`) + 2678400000 // +31days for end of the month
            let todayTS = new Date().valueOf()
            if (fcTS < todayTS) {
                this.$toasted.show(this.$t('lucking.noPastMonth'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});
            } else {
                if(this.selectedHalf != ''){
                    getBalance(this.userId , async(res)=>{
                        if (res < up.halfMonth) {
                            this.$toasted.show(this.$t('lucking.notEnough'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});
                        } else {
                            if (this.selectedLrs != '' ) {  
                                console.log('doLuckWithselectedLrs') 
                                await this.doLuckWithSelectedLrs(this.selectedLrs)
                                await this.updateUserInfo( this.selectedLrs)
                            } else {
                                if (this.selectedEstTime != '') {
                                    console.log('doLuckWithEstTime') 
                                    this.doLuckWithEstTime()
                                } else {
                                    if (this.lrs != '') {
                                        console.log('doLuckWithLrs') 
                                        this.doLuckWithLrs(this.lrs)  
                                    } else {
                                        console.log('doLuck') 
                                        this.doLuck() 
                                    }
                                }
                            }
                        }
                    })                
                } else {
                    this.$toasted.show(this.$t('lucking.noSelectedHalf'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000}); 
                }                
            }
        },
        async getForecastWithLrs(fcId){
            console.log(`getForecastWithLrs,fcId => ${fcId}`)      
            await verifyExstFC( this.userId , fcId , async(res)=> {
                if (res.length != 0 ) {
                    this.getExstFC(fcId)
                } else {         
                    await getDataWithDocId('ForecastHM' , fcId , async(res)=>{
                        if (res.length == 0) {
                            this.$toasted.show(this.$t('forecast.noForecastMsg'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000}); 
                        } else {
                            // this.fileUrl = res[0].fileUrl
                            // this.showForecast = true 
                            window.location.href= res[0].fileUrl
                            // window.open(res[0].fileUrl)
                            let slipId =`${this.$moment().format("YYMMDDHH")}-${getRandomInt(10000 , 90000)}`
                            await uaTxWallet( up.halfMonth * -1 , this.userId, slipId, "wallet", "exp" , fcId).then(()=>{
                                this.updateBalance(this.userId)
                            })
                            this.$toasted.show(this.$t('lucking.successLucking'), {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 5000});                   
                        }
                    })                 
                } 
            })



        },     
        
        async getExstFC(fcId) {
            this.$bvModal.msgBoxConfirm( this.$t('lucking.plsConfirm-noCost'), {
            title: this.$t('lucking.confirmViewExstFCMsg'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('refill.yes'),
            cancelTitle: this.$t('refill.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async(value) => {
                if (value) {
                    await getDataWithDocId('ForecastHM' , fcId , async(res)=>{
                        if (res.length == 0) {
                            this.$toasted.show(this.$t('forecast.noExstForecastMsg'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000}); 
                        } else {
                            window.location.href= res[0].fileUrl              
                        }
                    }) 
                } else {
                    return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-ViewExstFC: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        },    


        async doLuckWithSelectedLrs(selectedLrs) {
            let fcId = `${this.selectedYear.split('/')[0].trim()}${this.selectedMonth.split('/')[1]}${selectedLrs.split('/')[1]}${this.selectedHalf}`
                await this.getForecastWithLrs(fcId )
        },
        async doLuckWithEstTime() {              
            let ydTS = Date.parse(`${parseInt(this.selectedYearBD.split('/')[1])}/${parseInt(this.selectedMonthBD.split('/')[1])}/${parseInt(this.selectedDayBD)}`) - 86400000
            let yd = this.$moment(ydTS).format("D-M-YYYY")
            let dateYd = `${yd.split('-')[0]}-${yd.split('-')[1]}-${parseInt(yd.split('-')[2]) + 543}`                 
            let at24YdPos = await getCalendarWithDate(dateYd) || ''                  
            console.log(`at24YdPos => ${JSON.stringify(at24YdPos , null ,2)}`)
            if (at24YdPos == '') {
                this.$toasted.show(this.$t('lucking.noCalendarData'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});        
            } else {
                let lrs = parseInt(at24YdPos.snRs)
                let step = 3
                switch (this.selectedEstTime) {
                    case "t-06-12":
                        this.chrList = getRsCharacter(lrs, lrs + step)
                        break;
                    case "t-12-18":
                        this.chrList = getRsCharacter(lrs + 3, lrs + 3 + step )
                        break;
                    case "t-18-00":
                        this.chrList = getRsCharacter(lrs + 6, lrs + 6 + step)
                        break;
                    case "t-00-06":
                        this.chrList = getRsCharacter(lrs + 9, lrs +9 + step)
                        break;
                    case "t-xx-xx":
                        this.chrList = getRsCharacter(lrs, lrs + 11)
                        break;
                    default:
                        break;
                }
                this.showModalEstTime = true              
            }                               
        },
        async modalEstTime_OK(){
            await this.updateUserInfo( this.selectedChrLrs)
            this.showModalEstTime = false 
            this.lrs = this.selectedChrLrs
            let fcId = `${this.selectedYear.split('/')[0].trim()}${this.selectedMonth.split('/')[1]}${this.selectedChrLrs.split('/')[1]}${this.selectedHalf}`
            await this.getForecastWithLrs( fcId )
        },
        async doLuckWithLrs(lrs) {
                if (
                    this.prevFtName != this.ftName 
                    || this.prevDayBD != this.selectedDayBD 
                    || this.prevMonthBD != this.selectedMonthBD 
                    || this.prevYearBD != this.selectedYearBD 
                    || this.prevTimeBD != this.selectedTimeBD 
                    || this.prevPlaceBD != this.selectedPlaceBD 
                ) {
                    let msg = 'completed'
                    if (this.selectedDayBD ===''){
                        msg =this.$t('lucking.dayBDMsg')
                    } else if (this.selectedMonthBD ===''){
                        msg =this.$t('lucking.monthBDMsg')
                    } else if (this.selectedYearBD ===''){
                        msg =this.$t('lucking.yearBDMsg')
                    }           
                    if (msg === 'completed'){
                        // case: change place/date/time BD and ftName then apply full calculation.   
                        let ydTS = Date.parse(`${parseInt(this.selectedYearBD.split('/')[1])}/${parseInt(this.selectedMonthBD.split('/')[1])}/${parseInt(this.selectedDayBD)}`) - 86400000                
                        let yd = this.$moment(ydTS).format("D-M-YYYY")
                        let dateYd = `${yd.split('-')[0]}-${yd.split('-')[1]}-${parseInt(yd.split('-')[2]) + 543}`                    
                        let at24YdPos = await getCalendarWithDate(dateYd) || ''   
                        //console.log(`[doLuckWithLrs],at24YdPos => ${JSON.stringify(at24YdPos , null ,2)}`)                    
                        let ydPos= (parseInt(at24YdPos.snRs)*30 + parseInt(at24YdPos.snDeg))*60 + parseInt(at24YdPos.snLda)                                          
                        let offsetLoc = await offsetMinLoc(this.selectedPlaceBD)       
                        let srTdMinsLoc = getSunRiseTime(this.selectedMonthBD.split('/')[1] , this.selectedDayBD) - parseFloat(offsetLoc)                                  
                        let selectedRqrMinsLoc = parseInt(this.selectedTimeBD.split(':')[0])*60 + parseInt(this.selectedTimeBD.split(':')[1]) - parseFloat(offsetLoc)  //677
                        if (selectedRqrMinsLoc >= srTdMinsLoc) {
                            let dateTd = `${parseInt(this.selectedDayBD)}-${parseInt(this.selectedMonthBD.split('/')[1])}-${this.selectedYearBD.split('/')[0].trim()}`                    
                            let at24TdPos = await getCalendarWithDate(dateTd) || ''
                            if (at24YdPos == '' || at24TdPos == '') {
                                this.$toasted.show(this.$t('lucking.noCalendarData'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});        
                            } else {
                                //console.log(`[doLuckWithLrs],at24TdPos => ${JSON.stringify(at24TdPos , null ,2)}`) 
                                // let tdPos= (parseInt(at24TdPos.snRs)*30 + parseInt(at24TdPos.snDeg))*60 + parseInt(at24TdPos.snLda)  
                                // at 13 Apr , Sun Rasee change from 11 to 0. Then we offset today rasee to 12.
                                let tdPos= parseInt(at24TdPos.snRs) >= parseInt(at24YdPos.snRs) ? (parseInt(at24TdPos.snRs)*30 + parseInt(at24TdPos.snDeg))*60 + parseInt(at24TdPos.snLda)  : ((parseInt(at24TdPos.snRs)+12) *30 + parseInt(at24TdPos.snDeg))*60 + parseInt(at24TdPos.snLda)  
                                let rqrStrMvgLda = (Math.abs(tdPos - ydPos)/1440) * selectedRqrMinsLoc // 28.21
                                let rqrStrMvgLdaLoc = parseInt(at24YdPos.snLda) + rqrStrMvgLda  // 47.2
                                // console.log(`[doLuckWithLrs],sunRise Minutes, tdPos => ${tdPos}`)  
                                // console.log(`[doLuckWithLrs],sunRise Minutes, ydPos => ${ydPos}`) 
                                // console.log(`[doLuckWithLrs],sunRise Minutes, rqrStrMvgLda => ${rqrStrMvgLda}`)  
                                // console.log(`[doLuckWithLrs],sunRise Minutes, srTdMinsLoc => ${srTdMinsLoc}`)                    
                                // console.log(`[doLuckWithLrs],bdMins(selectedRqrMinsLoc => ${selectedRqrMinsLoc}`)
                                // console.log(`[doLuckWithLrs],selectedPlaceBD => ${this.selectedPlaceBD}`)
                                await getLrsFromSr(parseInt(at24YdPos.snRs), parseInt(at24YdPos.snDeg), rqrStrMvgLdaLoc, selectedRqrMinsLoc, srTdMinsLoc, async(res)=>{
                                    await this.updateUserInfo( res.rsName)
                                    console.log(`[doLuckWithLrs],currentRqrAnto, Lucking =>  ${JSON.stringify(res , null ,2)}`)
                                    this.lrs = res.rsName
                                    let fcId = `${this.selectedYear.split('/')[0].trim()}${this.selectedMonth.split('/')[1]}${this.selectedHalf}${res.rsName.split('/')[1]}`
                                    await this.getForecastWithLrs( fcId )
                                })                        
                            }  
                        } else {
                            let b4YdTS = Date.parse(`${parseInt(this.selectedYearBD.split('/')[1])}/${parseInt(this.selectedMonthBD.split('/')[1])}/${parseInt(this.selectedDayBD)}`) - 172800000                
                            let b4Yd = this.$moment(b4YdTS).format("D-M-YYYY")
                            let dateB4Yd = `${b4Yd.split('-')[0]}-${b4Yd.split('-')[1]}-${parseInt(b4Yd.split('-')[2]) + 543}`  
                            let at24B4YdPos = await getCalendarWithDate(dateB4Yd) || ''                                 
                            if (at24YdPos == '' || at24B4YdPos == '') {
                                this.$toasted.show(this.$t('lucking.noCalendarData'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});        
                            } else {
                                
                                let b4YdPos= (parseInt(at24B4YdPos.snRs)*30 + parseInt(at24B4YdPos.snDeg))*60 + parseInt(at24B4YdPos.snLda)  
                                let ydDDMM = this.$moment(ydTS).format("DD-MM-YYYY")
                                let srYdMinsLoc = getSunRiseTime(ydDDMM.split('-')[1] , ydDDMM.split('-')[0]) - parseFloat(offsetLoc)       
                                let rqrMinsLoc = 1440 + selectedRqrMinsLoc   // Start from at24B4Yd to selectedRqrMinsLoc
                                // at 13 Apr , Sun Rasee change from 11 to 0. but yesterday and before yesterday still rs11 tnen no offset.
                                // if today = 14 Apr, YdRs = 0 and B4YdRs = 11 , then we need offset 12 at YdRs.
                                //  let rqrStrMvgLda = (Math.abs(ydPos-b4YdPos)/1440) * rqrMinsLoc //                                 
                                let ydPos_rs_B4YdMoreYd= parseInt(at24YdPos.snRs) >= parseInt(at24B4YdPos.snRs) ? null : ((parseInt(at24YdPos.snRs)+12)*30 + parseInt(at24YdPos.snDeg))*60 + parseInt(at24YdPos.snLda)      
                                let rqrStrMvgLda =parseInt(at24YdPos.snRs) >= parseInt(at24B4YdPos.snRs) ?  (Math.abs(ydPos - b4YdPos)/1440) * rqrMinsLoc : (Math.abs(ydPos_rs_B4YdMoreYd - b4YdPos)/1440) * rqrMinsLoc 
                                let rqrStrMvgLdaLoc = parseInt(at24B4YdPos.snLda) + rqrStrMvgLda  //  Sun Pos from Before Yesterday.
                                // console.log(`[doLuckWithLrsB4Sr],at24B4YdPos => ${JSON.stringify(at24B4YdPos , null ,2)}`) 
                                // console.log(`[doLuckWithLrsB4Sr],sunRise Minutes, rqrStrMvgLda => ${rqrStrMvgLda}`)  
                                // console.log(`[doLuckWithLrsB4Sr],sunRise Minutes, b4YdPos => ${b4YdPos}`)
                                // console.log(`[doLuckWithLrsB4Sr],sunRise Minutes, ydPos => ${ydPos}`)  
                                // console.log(`[doLuckWithLrsB4Sr],sunRise Minutes, ydPos_rs_B4YdMoreYd => ${ydPos_rs_B4YdMoreYd}`) 
                                // console.log(`[doLuckWithLrsB4Sr],sunRise Minutes, srYdMinsLoc => ${srYdMinsLoc}`)                    
                                // console.log(`[doLuckWithLrsB4Sr],bdMins(rqrMinsLoc) => ${rqrMinsLoc}`)
                                // console.log(`[doLuckWithLrsB4Sr],selectedPlaceBD => ${this.selectedPlaceBD}`)
                                await getLrsFromSr(parseInt(at24B4YdPos.snRs), parseInt(at24B4YdPos.snDeg), rqrStrMvgLdaLoc, rqrMinsLoc, srYdMinsLoc , async(res)=>{
                                    await this.updateUserInfo( res.rsName)
                                    // console.log(`[doLuckWithLrsB4Sr],currentRqrAnto, Lucking =>  ${JSON.stringify(res , null ,2)}`)
                                    this.lrs = res.rsName
                                    let fcId = `${this.selectedYear.split('/')[0].trim()}${this.selectedMonth.split('/')[1]}${res.rsName.split('/')[1]}${this.selectedHalf}`
                                    await this.getForecastWithLrs( fcId )
                                })                        
                            }                        
                        }     
                    }else{
                        this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
                    }
                } else {
                    let fcId = `${this.selectedYear.split('/')[0].trim()}${this.selectedMonth.split('/')[1]}${lrs.split('/')[1]}${this.selectedHalf}`
                    await this.getForecastWithLrs(fcId )
                }
        },
        async doLuck() {
            let msg = 'completed'
            if (this.ftName === ''){
                msg = this.$t("lucking.nameMsg")
            } else if (this.selectedDayBD ===''){
                msg =this.$t('lucking.dayBDMsg')
            } else if (this.selectedMonthBD ===''){
                msg =this.$t('lucking.monthBDMsg')
            } else if (this.selectedYearBD ===''){
                msg =this.$t('lucking.yearBDMsg')
            } else if (this.selectedPlaceBD ===''){
                msg =this.$t('lucking.placeBDMsg')        
            } else if (this.selectedTimeBD === ''){ 
                msg = this.$t('lucking.timeBDMsg')
            }
            if (msg === 'completed'){
                // case: change place/date/time BD and ftName then apply full calculation.   
                let ydTS = Date.parse(`${parseInt(this.selectedYearBD.split('/')[1])}/${parseInt(this.selectedMonthBD.split('/')[1])}/${parseInt(this.selectedDayBD)}`) - 86400000                
                let yd = this.$moment(ydTS).format("D-M-YYYY")
                let dateYd = `${yd.split('-')[0]}-${yd.split('-')[1]}-${parseInt(yd.split('-')[2]) + 543}`                    
                let at24YdPos = await getCalendarWithDate(dateYd) || ''   
                // console.log(`[doLuck],at24YdPos => ${JSON.stringify(at24YdPos , null ,2)}`)                    
                let ydPos= (parseInt(at24YdPos.snRs)*30 + parseInt(at24YdPos.snDeg))*60 + parseInt(at24YdPos.snLda)                                          
                let offsetLoc = await offsetMinLoc(this.selectedPlaceBD)       
                let srTdMinsLoc = getSunRiseTime(this.selectedMonthBD.split('/')[1] , this.selectedDayBD) - parseFloat(offsetLoc)                                  
                let selectedRqrMinsLoc = parseInt(this.selectedTimeBD.split(':')[0])*60 + parseInt(this.selectedTimeBD.split(':')[1]) - parseFloat(offsetLoc)  //677
                if (selectedRqrMinsLoc >= srTdMinsLoc) {
                    let dateTd = `${parseInt(this.selectedDayBD)}-${parseInt(this.selectedMonthBD.split('/')[1])}-${this.selectedYearBD.split('/')[0].trim()}`                    
                    let at24TdPos = await getCalendarWithDate(dateTd) || ''
                    if (at24YdPos == '' || at24TdPos == '') {
                        this.$toasted.show(this.$t('lucking.noCalendarData'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});        
                    } else { 
                        let tdPos= parseInt(at24TdPos.snRs) >= parseInt(at24YdPos.snRs) ? (parseInt(at24TdPos.snRs)*30 + parseInt(at24TdPos.snDeg))*60 + parseInt(at24TdPos.snLda)  : ((parseInt(at24TdPos.snRs)+12) *30 + parseInt(at24TdPos.snDeg))*60 + parseInt(at24TdPos.snLda)  
                        let rqrStrMvgLda = (Math.abs(tdPos - ydPos)/1440) * selectedRqrMinsLoc // 28.21
                        let rqrStrMvgLdaLoc = parseInt(at24YdPos.snLda) + rqrStrMvgLda  // 47.2
                        // console.log(`[doLuck],at24TdPos => ${JSON.stringify(at24TdPos , null ,2)}`)
                        // console.log(`[doLuck],sunRise Minutes, rqrStrMvgLda => ${rqrStrMvgLda}`)  
                        // console.log(`[doLuck],sunRise Minutes, tdPos => ${tdPos}`)  
                        // console.log(`[doLuck],sunRise Minutes, ydPos => ${ydPos}`) 
                        // console.log(`[doLuck],sunRise Minutes, srTdMinsLoc => ${srTdMinsLoc}`)                    
                        // console.log(`[doLuck],bdMins(selectedRqrMinsLoc) => ${selectedRqrMinsLoc}`)
                        // console.log(`[doLuck],selectedPlaceBD => ${this.selectedPlaceBD}`)
                        await getLrsFromSr(parseInt(at24YdPos.snRs), parseInt(at24YdPos.snDeg), rqrStrMvgLdaLoc, selectedRqrMinsLoc, srTdMinsLoc, async(res)=>{
                            await this.updateUserInfo( res.rsName)
                            console.log(`[doLuck],currentRqrAnto, Lucking =>  ${JSON.stringify(res , null ,2)}`)
                            this.lrs = res.rsName
                            let fcId = `${this.selectedYear.split('/')[0].trim()}${this.selectedMonth.split('/')[1]}${res.rsName.split('/')[1]}${this.selectedHalf}`
                            await this.getForecastWithLrs( fcId )
                        })                        
                    }  
                } else {
                    let b4YdTS = Date.parse(`${parseInt(this.selectedYearBD.split('/')[1])}/${parseInt(this.selectedMonthBD.split('/')[1])}/${parseInt(this.selectedDayBD)}`) - 172800000                
                    let b4Yd = this.$moment(b4YdTS).format("D-M-YYYY")
                    let dateB4Yd = `${b4Yd.split('-')[0]}-${b4Yd.split('-')[1]}-${parseInt(b4Yd.split('-')[2]) + 543}`  
                    let at24B4YdPos = await getCalendarWithDate(dateB4Yd) || ''                                 
                    if (at24YdPos == '' || at24B4YdPos == '') {
                        this.$toasted.show(this.$t('lucking.noCalendarData'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});        
                    } else {
                        let b4YdPos= (parseInt(at24B4YdPos.snRs)*30 + parseInt(at24B4YdPos.snDeg))*60 + parseInt(at24B4YdPos.snLda)  
                        let ydDDMM = this.$moment(ydTS).format("DD-MM-YYYY")
                        let srYdMinsLoc = getSunRiseTime(ydDDMM.split('-')[1] , ydDDMM.split('-')[0]) - parseFloat(offsetLoc)       
                        let rqrMinsLoc = 1440 + selectedRqrMinsLoc   // Start from at24B4Yd to selectedRqrMinsLoc
                        // at 13 Apr , Sun Rasee change from 11 to 0. but yesterday and before yesterday still rs11 tnen no offset.
                        // if today = 14 Apr, YdRs = 0 and B4YdRs = 11 , then we need offset 12 at YdRs   
                        let ydPos_rs_B4YdMoreYd = parseInt(at24YdPos.snRs) >= parseInt(at24B4YdPos.snRs) ? null : ((parseInt(at24YdPos.snRs)+12)*30 + parseInt(at24YdPos.snDeg))*60 + parseInt(at24YdPos.snLda)      
                        let rqrStrMvgLda =parseInt(at24YdPos.snRs) >= parseInt(at24B4YdPos.snRs) ?  (Math.abs(ydPos - b4YdPos)/1440) * rqrMinsLoc : (Math.abs(ydPos_rs_B4YdMoreYd - b4YdPos)/1440) * rqrMinsLoc 
                        let rqrStrMvgLdaLoc = parseInt(at24B4YdPos.snLda) + rqrStrMvgLda  //  Sun Pos from Before Yesterday.
                        // console.log(`[doLuckB4Sr],at24B4YdPos => ${JSON.stringify(at24B4YdPos , null ,2)}`)
                        // console.log(`[doLuckB4Sr],sunRise Minutes, rqrStrMvgLda => ${rqrStrMvgLda}`)  
                        // console.log(`[doLuckB4Sr],sunRise Minutes, b4YdPos => ${b4YdPos}`)
                        // console.log(`[doLuck],sunRise Minutes, ydPos => ${ydPos}`) 
                        // console.log(`[doLuckB4Sr],sunRise Minutes, ydPos_rs_B4YdMoreYd => ${ydPos_rs_B4YdMoreYd}`)  
                        // console.log(`[doLuckB4Sr],sunRise Minutes, srYdMinsLoc => ${srYdMinsLoc}`)                    
                        // console.log(`[doLuckB4Sr],bdMins(rqrMinsLoc) => ${rqrMinsLoc}`)
                        // console.log(`[doLuckB4Sr],selectedPlaceBD => ${this.selectedPlaceBD}`)
                        await getLrsFromSr(parseInt(at24B4YdPos.snRs), parseInt(at24B4YdPos.snDeg), rqrStrMvgLdaLoc, rqrMinsLoc, srYdMinsLoc , async(res)=>{
                            await this.updateUserInfo( res.rsName)
                            // console.log(`[doLuckB4Sr],currentRqrAnto, Lucking =>  ${JSON.stringify(res , null ,2)}`)
                            this.lrs = res.rsName
                            let fcId = `${this.selectedYear.split('/')[0].trim()}${this.selectedMonth.split('/')[1]}${res.rsName.split('/')[1]}${this.selectedHalf}`
                            await this.getForecastWithLrs(fcId)
                        })                        
                    }                        
                }     
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
        async updateUserInfo(lrs){
            let payload = {
                name: this.name,
                ftName: this.ftName,
                dayBD: this.selectedDayBD,
                monthBD:  this.selectedMonthBD,
                yearBD: this.selectedYearBD,
                timeBD: this.selectedTimeBD,
                placeBD: this.selectedPlaceBD,                            
                lrs: lrs || '',
            }
            await saveWithId('Users', this.userId, payload).then(()=>{
            })   
        },
        toggleGradient() {
            this.useGradientA = !this.useGradientA;
        },
        noTimeBD_BTN(){
            this.selectedTimeBD = ''
            this.showNoTimeBD_BTN = false
            this.statusTimeBD = 'accepted'
        },
        // generateReport () {
        //     this.$refs.html2Pdf.generatePdf()
        // },
        toggle_fullscreen() {
            if ((document.fullScreenElement && document.fullScreenElement !== null) ||
                (!document.mozFullScreen && !document.webkitIsFullScreen)) {
                if (document.documentElement.requestFullScreen) {
                document.documentElement.requestFullScreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullScreen) {
                document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.cancelFullScreen) {
                document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
                }
            }
        }
    }
}
</script>
<style scoped>
.frameB {
    max-width: 100%;
    height: auto;
    border-radius: 5px;
}
.frameT {
    width: 100%;
    height: 100%;
    border-radius: 5px;
}
.pdfLogo {
    width: 100%;
    height: 100%;
}
.pdfFrameB {
    width: 80%;
    height: 80%;
    border-radius: 5px;
}
.gradient-gy {
  background: linear-gradient(135deg, green, yellow);
}
.gradient-yg {
  background: linear-gradient(135deg, yellow, green);
}

.gradient-rbl {
  background: linear-gradient(45deg, red, blue);
}

.gradient-gr {
  background: linear-gradient(45deg, green, red);
}
.gradient-rw {
  background: linear-gradient(45deg, rgb(255, 166, 0), white);
}
.gradient-gw {
  background: linear-gradient(45deg, green, white);
}
.gradient-wg {
  background: linear-gradient(45deg, white, green);
}
.gradient-pw {
  background: linear-gradient(45deg, pink, white);
}


</style>
